import React from 'react';
import { Link } from 'react-router-dom';
import arrowCircleRightFilled from '../../../../../assets/img/arrow_circle_right_filled.png';

const FailedChallengePopoverContent = ({ retakeTime }) => {
  return (
    <div className="helpWrapper">
      <h4 className="helpTitle">Don't worry!</h4>
      <h4 className="helpSubTitle">
        Here’s what you can do if you didn’t pass this Challenge:
      </h4>
      <span className="helpTipWrapper">
        <img src={arrowCircleRightFilled} />
        <p className="helpTip">
          <Link to="/dashboard/turing_test">Update your Tech Stacks </Link> to
          pick one that better fits your skills.
        </p>
      </span>
      <span className="helpTipWrapper">
        <img src={arrowCircleRightFilled} />
        <p className="helpTip">
          If you think something’s wrong, you can contact{' '}
          <a href="mailto:support@turing.com"> Turing Support</a>.
        </p>
      </span>
      <span className="helpTipWrapper">
        <img src={arrowCircleRightFilled} />
        <p className="helpTip"> Wait {retakeTime} to take this Challenge again.</p>
      </span>
    </div>
  );
};

export default FailedChallengePopoverContent;
